export default {
  selectedDetails: null,
  paymentStatusL: null,
  selected: null,
};
